/* eslint-disable react/no-unescaped-entities */
import { useMemo } from 'react';
import { Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { useTable, useExpanded } from 'react-table';
import ReactTableRender from '../../../../../Components/ReactTable/ReactTableRender';
// import { ThematicAreaBadge } from '../../../../../Components/ThematicAreaBadge';

function OverallEventsTable({ loading, eventsData, handleSummaryTableNameChange }) {
  const columns = useMemo(
    () => [
      {
        Header: <FormattedMessage id="province" />,
        accessor: 'province'
      },
      {
        Header: <FormattedMessage id="total_events" />,
        accessor: 'totalEvents'
      },
      {
        Header: <FormattedMessage id="thematic_area_covered" />,

        accessor: 'thematicAreasCovered'
        // Cell: ({ row, cell: { value } }) => (
        //   <span className="d-flex align-items-center flex-wrap">
        //     {Boolean(value) && (
        //       <>
        //         {value.length > 3 ? (
        //           <span className="small text-secondary" {...row.getToggleRowExpandedProps()}>
        //             {row.isExpanded ? (
        //               <div>
        //                 <span>👇</span>
        //                 <div>
        //                   {value.map((target, index) => (
        //                     <ThematicAreaBadge key={index}>{target}</ThematicAreaBadge>
        //                   ))}
        //                 </div>
        //               </div>
        //             ) : (
        //               <div>
        //                 {value.slice(0, 3).map((target, index) => (
        //                   <ThematicAreaBadge key={index}>{target}</ThematicAreaBadge>
        //                 ))}
        //                 +{value.length - 3} more 👉
        //               </div>
        //             )}
        //           </span>
        //         ) : null}
        //       </>
        //     )}
        //   </span>
        // )
      },

      {
        id: 'report.enrolled_participants_col',
        Header: <FormattedMessage id="report.enrolled_participants" />,
        className: 'text-center',
        columns: [
          {
            Header: <FormattedMessage id="male" />,

            accessor: 'en_parti_male'
          },
          {
            Header: <FormattedMessage id="female" />,

            accessor: 'en_parti_female'
          },
          {
            Header: <FormattedMessage id="other" />,

            accessor: 'en_parti_other'
          },
          {
            Header: <FormattedMessage id="caste_group" />,
            accessor: 'en_parti_samuha',
            Cell: ({ cell: { value } }) => (
              <div>
                {Object.entries(value).map(([key, value], index) => (
                  <span key={index} className="d-block">
                    <span>{key}:</span>
                    <span> {value}</span>
                  </span>
                ))}
              </div>
            )
          },
          {
            Header: <FormattedMessage id="total" />,

            accessor: 'en_parti_total'
          }
        ]
      },
      {
        id: 'Enrolled Resource Person_col',
        Header: <FormattedMessage id="report.enrolled_resource_person" />,
        className: 'text-center',
        columns: [
          {
            Header: <FormattedMessage id="male" />,

            accessor: 'en_resor_male'
          },
          {
            Header: <FormattedMessage id="female" />,

            accessor: 'en_resor_female'
          },
          {
            Header: <FormattedMessage id="other" />,

            accessor: 'en_resor_other'
          },
          {
            Header: <FormattedMessage id="total" />,

            accessor: 'en_resor_total'
          }
        ]
      },
      {
        Header: <FormattedMessage id="actions" />,

        accessor: 'action',
        Cell: ({ row: { original } }) => (
          <div>
            <Button
              variant="outline-info"
              style={{ width: '80px' }}
              className="btn btn-sm btn-outline-info ms-3"
              onClick={() => {
                handleSummaryTableNameChange(original.province);
              }}>
              <FormattedMessage id="button.seeAll" />
            </Button>
          </div>
        )
      }
    ],
    []
  );

  const data = useMemo(() => {
    if (!eventsData) return [];
    return eventsData.map((result) => {
      return {
        province: result.targeted_area,
        totalEvents: result.data.total_events,
        thematicAreasCovered: result.data.total_thematic_areas_covered,
        en_parti_male: result.data.participant_details.male,
        en_parti_female: result.data.participant_details.female,
        en_parti_other: result.data.participant_details.gender_minorities,
        en_parti_samuha: result.data.participant_details.samuha,
        en_parti_total: result.data.participant_details.total,
        en_resor_male: result.data.resource_person_details.male,
        en_resor_female: result.data.resource_person_details.female,
        en_resor_other: result.data.resource_person_details.gender_minorities,
        en_resor_total: result.data.resource_person_details.total
      };
    });
  }, [eventsData]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, visibleColumns } =
    useTable(
      {
        columns,
        data
      },
      useExpanded
    );

  return (
    <div>
      <ReactTableRender
        getTableProps={getTableProps}
        headerGroups={headerGroups}
        getTableBodyProps={getTableBodyProps}
        page={rows}
        prepareRow={prepareRow}
        visibleColumns={visibleColumns}
        pagination={false}
        loading={loading}
        noFilters={true}
      />
    </div>
  );
}

export default OverallEventsTable;
